import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, makeObservable, observable } from "mobx";
import defined from "terriajs-cesium/Source/Core/defined";
import GroupMixin from "../../ModelMixins/GroupMixin";
let SearchResult = (_class = class SearchResult {
  constructor(options) {
    var _options$name, _options$isImportant;
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "tooltip", _descriptor2, this);
    _initializerDefineProperty(this, "isImportant", _descriptor3, this);
    _initializerDefineProperty(this, "clickAction", _descriptor4, this);
    _initializerDefineProperty(this, "catalogItem", _descriptor5, this);
    _initializerDefineProperty(this, "isOpen", _descriptor6, this);
    _initializerDefineProperty(this, "type", _descriptor7, this);
    _initializerDefineProperty(this, "location", _descriptor8, this);
    makeObservable(this);
    this.name = (_options$name = options.name) !== null && _options$name !== void 0 ? _options$name : "Unknown";
    this.tooltip = options.tooltip;
    this.isImportant = (_options$isImportant = options.isImportant) !== null && _options$isImportant !== void 0 ? _options$isImportant : false;
    this.clickAction = options.clickAction;
    this.catalogItem = options.catalogItem;
    this.location = options.location;
  }
  toggleOpen() {
    if (!defined(this.catalogItem)) {
      return;
    }
    this.isOpen = !this.isOpen;

    // Load this group's items (if we haven't already) when it is opened.
    if (this.isOpen && GroupMixin.isMixedInto(this.catalogItem)) {
      this.catalogItem.loadMembers().then(result => result.raiseError(this.catalogItem.terria));
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tooltip", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isImportant", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "clickAction", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "catalogItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "type", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "search_result";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "location", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "toggleOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleOpen"), _class.prototype), _class);
export { SearchResult as default };